import { render, staticRenderFns } from "./PageLinkIcon.vue?vue&type=template&id=1cf02594&"
import script from "./PageLinkIcon.vue?vue&type=script&lang=js&"
export * from "./PageLinkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports